import Vue from 'vue';
import store from '@/js/store';

const initVue = (element, Class) => {
  new Vue({
    render: h => h(Class, {
      props: { dataset: { ...element.dataset } },
    }),
    store,
  }).$mount(element);
};

const initSvelte = (element, Class) => {
  // eslint-disable-next-line no-new
  new Class({
    target: element,
    props: { dataset: { ...element.dataset } },
  });
};

const initWidget = (element, Class, instanceName) => {
  let $element;
  if (process.env.TYPE === 'new') {
    $element = element;
  } else {
    $element = $(element);
  }
  const instance = new Class($element);

  if (instanceName) {
    if ($element.jquery) {
      $element.data(instanceName, instance);
    } else {
      $element.dataset.instanceName = instance;
    }
  }
};

export default function (elements, Class, type, instanceName) {
  let elementsList;
  if (process.env.TYPE === 'new') {
    elementsList = elements instanceof NodeList ? elements : document.querySelectorAll(elements);
  } else {
    elementsList = $(elements);
  }

  for (let i = 0; i < elementsList.length; i += 1) {
    const element = elementsList[i];
    if (type === 'widget') {
      initWidget(element, Class, instanceName);
    }

    if (type === 'vue') {
      initVue(element, Class);
    }

    if (type === 'svelte') {
      initSvelte(element, Class);
    }
  }
}
